module.exports = __webpack_public_path__ + "print_white_bold.png?9e6ef701834eba8ac59002328ee766b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print_white_bold.png
// module id = 660
// module chunks = 0 2 7 8 9 10 19